<div class="popover-team">

  <div class="popover-row">
    <div class="popover-flex">
      <i *ngIf="teamVehicle?.vehicle?.id" class="far fa-user-friends fa-xl"></i>
      <img *ngIf="!teamVehicle?.vehicle?.id" class="image-rounded" [src]="imgRoundedTeam" alt="" />
      <h4 class="text-overflow" style="width: 220px; font-size: 16px;">{{teamVehicle?.name}}</h4>
    </div>
    <div style="position: relative;" *ngIf="teamVehicle?.vehicle?.id">
      <i class="far fa-clipboard-list-check text-muted fa-2xl"></i>
      <div class="number-task-popover">{{teamVehicle?.totalTasksToday}}</div>
    </div>
  </div>

  <div class="d-flex">
    <h4>Atualizado: <span class="text-muted ml-1" style="font-weight: 400">{{teamVehicle?.location?.createdAt|date:
        'dd/MM/yyyy - HH:mm'}}</span>
    </h4>
  </div>

  <div class="popover-row">
    <div class="popover-flex" *ngIf="teamVehicle?.vehicle?.id">
      <!-- Imagem da equipe -->
      <img class="image-rounded" [src]="imgRoundedTeam" alt="" />

      <!-- Ícone de link -->
      <i class="fa-solid fa-link text-muted"></i>

      <!-- Imagem do veículo -->
      <img class="image-rounded" [src]="imgRoundedVehicle" alt="" />
    </div>

    <button (click)="openTeamVehicleDetails()" [id]="'detailsViewPopupTeam' + teamVehicle?.teamId"
      class="btn btn-link detail-sidebar-button ml-auto">
      VER DETALHES <i class="fas fa-angle-right ml-2 mr-0" style="font-size: 20px;"></i>
    </button>

  </div>
</div>
